module.exports = __webpack_public_path__ + "img/HeaderLayoutL.c57eec21.jpg";